export default __webpack_public_path__ + "static/media/android-guide3.485587a3.png";